import React from 'react';
import PropTypes from 'prop-types';

const DischargeTypesPage = () => {

  // Discharge types content
  const dischargeTypes = [
    {
      title: "Successful Discharge",
      description: "Client has completed the program and/or has decided to move on in their recovery. Client is aware of discharge date and will have belongings ready the morning of discharge no later than 10am."
    },
    {
      title: "Involuntary Discharge",
      description: "Client has violated rules or relapsed. Work with the client to help them get to a higher level of care or a safe place. Call client's emergency contact and/or individual on release to inform them of what has taken place and process. Staff will assist client with getting their belongings for the next phase or discharge immediately, when safe for the client. Client has a minimum of two hours to leave property."
    },
    {
      title: "Abandonment Discharge",
      description: "Client left and never returned for one reason or another. We are to secure their items and attempt to contact family or listed individuals on release for 30 days then items get donated. Client has a minimum of two hours to leave property."
    },
    {
      title: "Voluntary Discharge",
      description: "Client has decided to leave prior to scheduled discharge. Staff will assist client in safely transitioning. Clients' emergency contact will be contacted and notified. Staff will assist client with getting their belongings for the next phase or discharge immediately, when safe for the client. Client has a minimum of two hours to leave property."
    }
  ];

  return (
    <div style={{ fontFamily: "Elef Layla MF", padding: "20px", maxWidth: "800px", margin: "0 auto", lineHeight: "1.2",fontSize: "14pt",height: "600px" }}>

      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "16pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            paddingBottom: "0px",
          }}
        >
          TYPES OF DISCHARGES FROM OUR FACILITY
        </h2>
      </div>

      {/* Discharge Types List */}
     {/* Discharge Types List */}
<div style={{ marginBottom: '20px' }}>
  {dischargeTypes.map((type, index) => (
    <div key={index} style={{ marginBottom: '15px' }}>
      <p style={{ marginLeft: '10px', marginBottom: '20px' }}>
        <strong>{type.title} - </strong>
        {type.description}
      </p>
    </div>
  ))}
</div>
    </div>
  );
};

DischargeTypesPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default DischargeTypesPage;